import { EnumRebateStatus } from '@wallet-manager/pfh-pmp-node-def-types/dist/src/DbModel/AgentRebate';
import { SingleSelection } from '../../../../components';
import { useTranslation } from '../../../../hooks';

interface IProps {
    label?: string;
    value: any;
    onChange: (e: any) => void;
    onClear: () => void;
}

const RebateStatusSingleSelection = (props: IProps) => {
    const { label, value, onChange, onClear } = props;
    const { tc, t } = useTranslation("EnumRebateStatus");

    return (
        <SingleSelection
            label={label || tc('phSelection', { fieldName: tc('rebateStatus') })}
            value={value || ''}
            onChange={onChange}
            clearSelect={onClear}
            enumData={EnumRebateStatus}
            nameFn={(item) => t(item)}
        />
    );
};

export default RebateStatusSingleSelection;
